'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/Toasts/toast';
import { useToast } from '@/components/ui/Toasts/use-toast';

// Pure renderer for the toast store. Fire toasts with toast() from
// @/components/ui/Toasts/use-toast; URL-carried toasts (server redirects) are
// handled by UrlToastBridge, not here.
export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider duration={5000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          // Tap/click anywhere dismisses. ToastAction and ToastClose stop
          // propagation so they don't also trigger this.
          <Toast key={id} {...props} onClick={() => dismiss(id)}>
            <div className="grid gap-0.5">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
